import {
    getClauseChecklistRelevanceStatus,
    readClauseChecklist,
    RelevanceJobStatus,
} from "@/api";
import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { RelevanceStatusIndicator } from "@/components/admin/indicators/RelevanceStatusIndicator";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { ClauseChecklistDetailsInfo } from "./components/clause-checklist-details/ClauseChecklistDetailsInfo";

/**
 * The details page for a clause checklist.
 */
const ClauseChecklistDetails = () => {
    const { clauseChecklistId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Checklist");

    const { data: clauseChecklist } = useSuspenseQuery({
        queryKey: ["admin-clause-checklist-details", clauseChecklistId],
        queryFn: () => readClauseChecklist(Number(clauseChecklistId)),
    });

    const { data: relevanceStatus, isLoading: isStatusLoading } = useQuery({
        queryKey: [
            "clause-checklist-relevance-status",
            Number(clauseChecklistId),
        ],
        queryFn: () =>
            getClauseChecklistRelevanceStatus(Number(clauseChecklistId)),
        refetchInterval: (query) => {
            const status = query.state.data?.status;
            const isPolling =
                status === RelevanceJobStatus.PENDING ||
                status === RelevanceJobStatus.PROCESSING;
            return isPolling ? 2000 : false;
        },
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Checklists", path: "checklists" },
            { label: clauseChecklist.name },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title={clauseChecklist.name}
                subtitle="Checklist configuration, fields, and topic assignments"
            >
                {" "}
                <RelevanceStatusIndicator
                    status={relevanceStatus?.status ?? RelevanceJobStatus.NONE}
                    isLoading={isStatusLoading}
                />
            </AdminPageHeader>

            <div className="mt-6">
                <ClauseChecklistDetailsInfo clauseChecklist={clauseChecklist} />
            </div>
        </AdminPageContent>
    );
};

export default ClauseChecklistDetails;
